


























































































































































import { Component, Vue } from "vue-property-decorator";
import viewBox from "@/components/viewBox.vue";
import { Overlay, Toast } from "vant";
import request from "@/api/index";
@Component({
  components: { viewBox, vanOverlay: Overlay }
})
export default class Answer extends Vue {
  // 定时器
  timenumber = this.$store.state.actDetail.ruleData.TEST_LIMIT_TIME * 60;
  time: any = null;
  // 是否答题
  isAnswer = true;
  // 是否提交答题
  issubmit = false;
  // 题目索引
  subjectIndex = 0;
  // ABCD------Z
  fromCharCodeList: string[] = [];
  show = false;
  // 题目id
  subjectId = 0;
  // 题目列表
  subjectList: any[] = [];
  //答题结果信息
  answerdetails: any = [];
  number = 0;
  mounted() {
    this.init();
  }
  beforeDestroy() {
    clearInterval(this.time);
  }
  init() {
    this.setfromCharCodeList();
    this.getExercise();
    // this.getdetails();
  }
  initData() {
    this.timenumber = this.$store.state.actDetail.ruleData.TEST_LIMIT_TIME * 60;
    this.time = null;
    this.isAnswer = true;
    this.issubmit = false;
    this.subjectIndex = 0;
    this.show = false;
    this.subjectList = [];
    this.answerdetails = [];
    document.title = "题目列表";
  }
  async getExercise() {
    const res = await request.getExercise();
    if (!res.code) {
      this.initData();
      for (let i = 0; i < res.data.questionList.length; i++) {
        res.data.questionList[i].selectanswer = [];
        res.data.questionList[i].answer = [];
      }
      this.subjectId = res.data.id;
      this.subjectList = res.data.questionList;
      this.time = setInterval(() => {
        if (this.timenumber == 0) {
          this.show = true;
          clearInterval(this.time);
          return;
        }
        this.timenumber--;
      }, 1000);
    } else {
      Toast(res.message);
      setTimeout(() => {
        this.$router.push("/cultivation");
      }, 2000);
    }
  }
  async answerFill(data: any) {
    const res = await request.answerFill(data);
    if (!res.code) {
      this.getdetails();
    }
  }
  async getdetails() {
    const res = await request.getdetails(this.subjectId);
    if (!res.code) {
      this.getstatistics();
      clearInterval(this.time);
      this.answerdetails = res.data;
      this.subjectList = res.data.questionList;
      for (let i = 0; i < this.subjectList.length; i++) {
        let ids: any = [];
        if (this.subjectList[i].userAnswer) {
          ids = this.subjectList[i].userAnswer.split("_").reverse();
        }
        this.subjectList[i].answer = [];
        this.subjectList[i].selectanswer = [];
        // this.subjectList[i].isTrue = this.answerdetails.isTrue
        for (let j = 0; j < this.subjectList[i].answerList.length; j++) {
          if (this.subjectList[i].answerList[j].isTrue) {
            this.subjectList[i].answer.push(j);
          }
          for (let z = 0; z < ids.length; z++) {
            if (this.subjectList[i].answerList[j].id == ids[z]) {
              this.subjectList[i].selectanswer.push(j);
            }
          }
        }
      }
      this.showAnswer();
      console.log(this.subjectList);
    }
  }
  async getstatistics() {
    const res = await request.getstatistics();
    if (!res.code) {
      this.number = res.data.enNumEveryDay;
    }
  }
  setfromCharCodeList() {
    for (let i = 0; i < 26; i++) {
      const str = "A";
      this.fromCharCodeList.push(String.fromCharCode(str.charCodeAt(0) + i));
    }
  }
  selectAnswers(index: number) {
    const selectanswer = this.subjectList[this.subjectIndex].selectanswer;
    const selectindex = selectanswer.indexOf(index);
    if (this.subjectList[this.subjectIndex].type == 1) {
      this.$set(selectanswer, 0, index);
    } else {
      if (selectindex == -1) {
        selectanswer.push(index);
      } else {
        selectanswer.splice(selectindex, 1);
      }
    }
  }
  isCorrect(item: any) {
    if (item.selectanswer.length == 0) {
      return false;
    }
    for (let i = 0; i < item.selectanswer.length; i++) {
      if (!item.isTrue) {
        return false;
      }
    }
    return true;
  }
  showAnswer() {
    this.show = false;
    document.title = "公布答案";
    this.isAnswer = false;
    setTimeout(() => {
      const el = this.$refs["answerbox"] as any;
      el.style.height = el.offsetHeight + 50 + "px";
    }, 100);
    this.answerFill(this.getsubmitData());
  }
  getsubmitData() {
    const data = {
      id: this.subjectId,
      ids: "",
      answers: ""
    };
    const ids: any = [];
    const answers: any = [];
    for (let i = 0; i < this.subjectList.length; i++) {
      ids.push(this.subjectList[i].id);
      const answerss = [];
      for (let j = 0; j < this.subjectList[i].selectanswer.length; j++) {
        answerss.push(
          this.subjectList[i].answerList[this.subjectList[i].selectanswer[j]].id
        );
      }
      answers.push(answerss.join("_"));
    }
    data.ids = ids.join(",");
    data.answers = answers.join(",");
    return data;
  }
  submit() {
    if (!this.isanswer()) return;
    if (this.issubmit) return;
    this.issubmit = true;
    this.answerFill(this.getsubmitData());
  }
  next() {
    if (!this.isanswer()) return;
    this.subjectIndex++;
  }
  isanswer() {
    if (this.subjectList[this.subjectIndex].selectanswer.length == 0) {
      Toast("请选择答案");
      return false;
    } else {
      return true;
    }
  }
  topage(path: string) {
    this.$router.push(path);
  }
}
